import { render, staticRenderFns } from "./ListOfTests.vue?vue&type=template&id=362ea090&scoped=true&"
import script from "./ListOfTests.vue?vue&type=script&lang=js&"
export * from "./ListOfTests.vue?vue&type=script&lang=js&"
import style0 from "./ListOfTests.vue?vue&type=style&index=0&id=362ea090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ea090",
  null
  
)

export default component.exports